import React from "react";

interface StepperProps {
  currentStep: number;
  steps: number[];
  labels: string[];
  setCurrentStep: (step: number) => void;
}

const Stepper: React.FC<StepperProps> = ({ currentStep, steps, labels, setCurrentStep }) => {
  return (
    <div className="flex flex-col items-center mb-6 mt-12">
      <div className="flex flex-wrap justify-center md:flex-nowrap items-center w-full max-w-4xl">
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <div className="flex flex-col items-center relative">
              <div
                className={`flex items-center justify-center w-10 h-10 rounded-full font-bold transition-all duration-300 ${
                  currentStep > step
                    ? "bg-gradient-to-r from-[#4CAF50] to-[#05e910] text-white"
                    : currentStep === step
                    ? "bg-white text-[#1c7a21] shadow-lg border border-[#1c7a21]"
                    : "bg-gray-200 text-gray-500"
                }`}
                aria-current={currentStep === step ? "step" : undefined}
                onClick={() => currentStep > step && setCurrentStep(step)}
              >
                {currentStep > step ? <img src="/featureIcons/check1.svg" alt="Checked" className="w-5 h-5 cursor-pointer" /> : step}
              </div>
              <span
                className={`mt-2 text-sm font-medium transition-colors duration-300 ${
                  currentStep >= step ? "text-black" : "text-gray-500"
                } hidden md:block`}
              >
                {labels[index]}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`flex-grow h-[4px] mx-4 rounded-full transition-all duration-300 ${
                  currentStep > step
                    ? "bg-gradient-to-r from-[#05e910] to-[#4CAF50]"
                    : "bg-gray-300"
                }`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Stepper;
